import {MELISSA_ID} from '../constants/APIKeys-obfuscated';

var error_codes = {};
error_codes['AE01'] = 'General Error';
error_codes['AE02'] = 'Unknown Street';
error_codes['AE03'] = 'Component Mismatch Error';
error_codes['AE05'] = 'Multiple Match';
error_codes['AE08'] = 'Sub Premise Number Invalid';
error_codes['AE09'] = 'Sub Premise Number Missing';
error_codes['AE10'] = 'Premise Number Invalid';
error_codes['AE11'] = 'Premise Number Missing';
error_codes['AE12'] = 'Box Number Invalid';
error_codes['AE13'] = 'Box Number Missing';
error_codes['AE14'] = 'PMB Number Missing';
error_codes['AE17'] = '';
export var error_codes;
/* Melissa APIs */
export const verifyAddress = (country, fulladdress) => {
  var url = `https://address.melissadata.net/V3/WEB/GlobalAddress/doGlobalAddress?id=${MELISSA_ID}&a1=${fulladdress}&ctry=${country}&format=JSON`;
  return fetch(url)
    .then((data) => {
      return data.json().then((result) => {
        if (
          result.hasOwnProperty('TotalRecords') &&
          result['TotalRecords'] !== '1'
        ) {
          return [];
        } else if (result.hasOwnProperty('Records')) {
          return result['Records'];
        } else {
          return [];
        }
      });
    })
    .catch((err) => {
      console.warn('err: ', err);
      // throw new Error(err.message);
    });
};
export const freeForm = (search_text, number_of_results) => {
  let urlParams = `id=${MELISSA_ID}&ff=${encodeURIComponent(
    search_text,
  )}&maxrecords=${number_of_results}&format=JSON`;
  return fetch(
    `https://expressentry.melissadata.net/web/ExpressFreeForm?${urlParams}`,
  )
    .then((data) => {
      return data
        .json()
        .then((result) => {
          return result;
        })
        .catch((err) => {});
    })
    .catch((err) => {});
};

export const globalFreeForm = (
  search_text,
  country,
  number_of_results,
) => {
  // Melissa's GlobalExpressFreeForm API spec has it returning latitude and longitude,
  // but this is actually an add-on service.

  let urlParams = `id=${MELISSA_ID}&ff=${encodeURIComponent(
    search_text,
  )}&maxrecords=${number_of_results}&country=${country}&format=JSON`;
  return fetch(
    `https://expressentry.melissadata.net/web/GlobalExpressFreeForm?${urlParams}`,
  )
    .then((data) => {
      return data
        .json()
        .then((result) => {
          return result;
        })
        .catch((err) => {});
    })
    .catch((err) => {});
};

export const cityState = (city, zip, number_of_results, state = '') => {
  let urlParams = `id=${MELISSA_ID}&city=${encodeURIComponent(
    city,
  )}&state=${state}&maxrecords=${number_of_results}&format=JSON`;

  if (zip) {
    urlParams = urlParams + `&postalcode=${zip}`;
  }
  return fetch(
    `https://expressentry.melissadata.net/web/ExpressCityState?${urlParams}`,
  )
    .then((data) => {
      return data
        .json()
        .then((result) => {
          return result;
        })
        .catch((err) => {});
    })
    .catch((err) => {});
};
